module.exports = __webpack_public_path__ + "static/media/waiting.87b7f58a.png";